import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { S_CircleCheck, S_HourglassHalf } from 'hosman-material';

import { Card, LoadingCircle } from 'hosman-material';

const PayementIframe = ({ payementDone, setPayementDone }) => {
  const { photoPacks: { lightshop_payment_form_url } } = useSelector((state) => state.sellerPhotoMeetings);
  const [isLoaded, setIsLoaded] = useState(false);
  const iframeRef = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      const iframe = iframeRef.current;
      if (!iframe || !iframe.contentWindow) return;

      try {
        const currentLocation = iframe.contentWindow.location;
        
        if (currentLocation.origin.includes('hosman.co') && currentLocation.hash === '#success') {
          setPayementDone(true);
          clearInterval(interval);
        }
      } catch (error) {
        console.warn("Impossible d'accéder à l'URL de l'iframe (cross-origin)");
      }
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <Card classes='w-full p-3'>
      {!isLoaded &&
        <div className='w-full flex justify-center'>
          <LoadingCircle />
        </div>
      }

      {payementDone && 
        <div className='w-full flex justify-center'>
          <div className='flex flex-col gap-3 py-8'>
            <div className='flex items-center gap-2'>
              <FontAwesomeIcon icon={S_CircleCheck} className='text-ih-green' />
              <p className='text-ih-green font-semibold'>Paiement effectué</p>
            </div>
            <div className='flex items-center gap-2'>
              <FontAwesomeIcon icon={S_HourglassHalf} className='text-ih-orange animate-spin' />
              <p className='text-ih-orange font-semibold'>Traitement de la demande</p>
            </div>
          </div>
        </div>
      }
        
      <iframe
        ref={iframeRef}
        src={lightshop_payment_form_url} 
        className={`w-full h-[450px] rounded-3xl ${(!isLoaded || payementDone) && 'hidden'}`} 
        onLoad={() => setIsLoaded(true)}>
      </iframe>
    </Card>
  )
}

export default PayementIframe;
